<template>
  <div class="depart-detail-modal">
    <mt-header class="detail-header" fixed title="渠道详情">
      <mt-button icon="back" slot="left"></mt-button>
    </mt-header>
    <div class="top">
      {{detailObj.departName}}
           <img v-if="!detailObj.collected" @click="collect" src="../../assets/app/star2.png">
      <img v-if="detailObj.collected" @click="deleteCollect" src="../../assets/app/starYellow.png">
    </div>
    <div class="data-table">
      <table cellspacing="0">
        <tr>
          <td>业务名称</td>
          <td>办理量</td>
        </tr>
        <tr v-for="item,i in detailObj.dataList" :key="i">
          <td>{{item.title}}</td>
          <td>{{item.day_count}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  import {Indicator, Toast} from 'mint-ui';
  import NoMessage from 'com/app/common/noMessage.vue';
  import commonMixin from 'mixins/common/common.js';
  import {formatDateTime} from "libs/common/common";
  export default {
    components: {
      NoMessage
    },
    mixins: [commonMixin],
    data() {
      return {
        xid: this.$route.query.xid || "",
        detailObj: {
          departName: "",
          departId: "",
          belongToId: "",
          collected: false,
          dataList: [
            {title: "99元套餐", day_count: "-", last_count: "-"},
            {title: "新增宽带完工量", day_count: "-", last_count: "-"},
            {title: "放号数", day_count: "-", last_count: "-"}
          ],
          collectParams: {
            type: 2,
            name: "",
            key: "ms.api.",
            params: ""
          }
        },
        city: "",
        eparchy: ""
      }
    },
    filters: {
      // 去掉数值前面的字母
      valueFromt: function (value) {
        if (!value) return "";
        if (value.includes("_")) {
          return value.slice(2);
        } else {
          return value;
        }
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    methods: {
      validateVal(value) {
        value = value.substring(0, value.length - 1);
        return Number(value)
      },
      getData() {
        let _this = this;
        Indicator.open();
        let params = {
          date: _this.time,
          city: "",
          eparchy: "",
          depart: _this.detailObj.departId
        };
        let level = _this.userInfo.level;
        if (level === 0) {
          params.eparchy = _this.chosenId;
        } else {
          params.city = _this.chosenId;
        }
        _this.$http.get(_this.$urls.getDepartTypeList, {
          params: params
        }).then((res) => {
          Indicator.close()
          if (res.data.code === 200) {
            for (let depart in res.data.data) {
              let departItem = res.data.data[depart];
              if (departItem._id === "99") {
                _this.detailObj.dataList[0]["day_count"] = departItem.day_count;
              } else if (departItem._id === "kd") {
                _this.detailObj.dataList[1].day_count = departItem.day_count;
              } else {
                _this.detailObj.dataList[2].day_count = departItem.day_count;
              }
            }
          }
        }).catch(error => {
          Indicator.close()
          console.log(error);
        });
      },
      collect () {
        let dt = new FormData();
        dt.append("type", this.detailObj.collectParams.type);
        dt.append("name", this.detailObj.collectParams.name);
        dt.append("key", this.detailObj.collectParams.key);
        dt.append("params", this.detailObj.collectParams.params);
        Indicator.open();
        this.$http.post(this.$urls.save, dt, {
          headers: {
            xid: this.xid
          }
        }).then(res => {
          Indicator.close();
          if (res.data.code === 200) {
            this.isStar = true;
            Toast({
              message: "操作成功",
              iconClass: "icon icon-success"
            });
          } else {
            Toast({
              message: "操作失败",
              iconClass: "icon icon-error"
            });
          }
        }).catch(error => {
          Indicator.close();
          console.log(error);
        });
      },
      deleteCollect () {
        Indicator.open();
        let dt = new FormData();
        dt.append("key", this.detailObj.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
        this.$http
          .post(this.$urls.delete, dt, {
            headers: {
              xid: this.xid
            }
          })
          .then(res => {
            Indicator.close();
            if (res.data.code === 200) {
              this.isStar = false;
              Toast({
                message: "操作成功",
                iconClass: "icon icon-error"
              });
            }
          })
          .catch(error => {
            Indicator.close();
            console.log(error);
          });
      },
      isCollected () {
        let dt = new FormData();
        dt.append("key", this.detailObj.collectParams.key); //收藏的key，也就是"ms.kpi." 加上指标的 id
        this.$http.post(this.$urls.isExisted, dt, {
          headers: {
            xid: this.xid
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.detailObj.collected = res.data.data.existed;
          }
        }).catch(error => {
          console.log(error);
        });
      },
    },
    created() {
      this.time = this.$route.query.date || formatDateTime(new Date(), "YYYY-MM-DD");
      let chosenId = this.$route.query.chosenId || "";
      this.depart = this.$route.query.departId || "";
      this.departName = this.$route.query.departName || "";
      let level = this.userInfo.level;
      if (level === 0) {
        this.eparchy = chosenId;
      } else {
        this.city = chosenId;
      }
      this.setTitle({'title': '渠道详情'});
      this.isCollected();
      this.getData();
    }
  }

</script>
<style lang="less" scoped>
  .depart-detail-modal {
    position: fixed;
    z-index: 6666;
    bottom: 0;
    background-color: #FFFFFF;
    top: 0;
    height: 100%;
    width: 100%;
    padding-top: .89rem;
    .detail-header {
      height: .89rem;
      background-color: #0384DF;
      font-size: .36rem;
    }
    .top {
      font-size: .3rem;
      height: 1.03rem;
      color: #43484D;
      line-height: 1.03rem;
      text-align: center;
      position: relative;
      img {
        width: .4rem;
        height: .4rem;
        position: absolute;
        top: 50%;
        right: .3rem;
        margin-top: -.2rem; /* 高度的一半 */
      }
    }

    .data-table {
      table {
        td {
          color: #86939E;
          font-size: .3rem;
          text-align: center;
          padding-top: .25rem;
          padding-bottom: .24rem;
          border-bottom: solid 1px #F4F5F7;
          &:first-child {
            width: 6rem;
            padding-left: .33rem;
            text-align: unset;
          }
        }
        tr:first-child {
          td {
            color: #43484D;
            background-color: #F3F4F6;
            width: 1.5rem;
            padding-top: .22rem;
            padding-bottom: .18rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/setMealDepartDetails.vue